import styled from "styled-components";

const FieldSet = styled.fieldset`
  border: 1px solid #06a7ed;
  legend {
    padding: 4px;
  }
`;
export default FieldSet;
